import { useEffect, useState } from 'react'

const getMatches = (query:string, fallbackMatches:boolean) => (
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query).matches
    : fallbackMatches
)

export const useMediaQuery = (query:string, fallbackMatches = false) => {
  const [matches, setMatches] = useState(() => getMatches(query, fallbackMatches))

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      setMatches(fallbackMatches)
      return
    }

    const mediaQuery = window.matchMedia(query)
    const updateMatches = () => setMatches(mediaQuery.matches)

    updateMatches()
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', updateMatches)
    } else {
      mediaQuery.addListener(updateMatches)
    }

    return () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', updateMatches)
      } else {
        mediaQuery.removeListener(updateMatches)
      }
    }
  }, [fallbackMatches, query])

  return matches
}
